import { render, staticRenderFns } from "./dailyAchievements.vue?vue&type=template&id=87365954&scoped=true"
import script from "./dailyAchievements.vue?vue&type=script&lang=js"
export * from "./dailyAchievements.vue?vue&type=script&lang=js"
import style0 from "./dailyAchievements.vue?vue&type=style&index=0&id=87365954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87365954",
  null
  
)

export default component.exports